import React from 'react';
import Form from 'mobx-react-form';
import { Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { DateTime } from 'luxon';

import { SALE_CONDITIONS_OPTIONS } from '../constants';

type SaleConditionProps = {
  salesHistoryItem: any;
  index: number;
  form: Form;
};

const SaleCondition = observer(({ form, salesHistoryItem, index }: SaleConditionProps) => {
  return (
    <>
      <Typography variant="subtitle1">
        <strong>
          {salesHistoryItem.date ? DateTime.fromISO(salesHistoryItem.date).toFormat('MM-dd-yyyy') : ''} Sale Condition
        </strong>
      </Typography>
      <FormControl>
        <RadioGroup
          {...form.$(`propertyHistory.salesHistory.${index}.saleCondition`).bind()}
          row
          sx={{ minHeight: 40, mt: '-16px' }}
        >
          {SALE_CONDITIONS_OPTIONS.map(({ value, label }) => (
            <FormControlLabel control={<Radio />} key={value} sx={{ mb: 3 / 4 }} {...{ label, value }} />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
});

export default SaleCondition;
